<template>
  <div>
    <section v-for="(list, i) in orthogonalRestLists" :key="i" class="section">
      <section-heading>{{ list.title }}</section-heading>
      <div class="small-card-list-wrapper">
        <ul class="small-card-list">
          <li
            v-for="rest in list.rests"
            :key="rest.id"
            class="small-card-list-item"
          >
            <card-small
              @showLaterOrderModal="showLaterOrderModal"
              :name="rest.name"
              :waitTime="rest.waitTime"
              :categories="rest.categories"
              :image="rest.image"
              :url="rest.url"
              :restId="rest.id"
              :openTime="rest.openTime"
              :open="rest.open === 1"
              :hours="rest.hours"
              :deliveryFee="rest.fee"
              :distance="rest.distance"
            />
          </li>
        </ul>
      </div>
    </section>
    <modal v-if="showLaterOrder" @hideModal="hideLaterOrderModal">
      <later-order-same-hours
        @goToMenu="
          hideLaterOrderModal()
          goToMenu()
        "
        :restId="restId"
        :hours="hours"
        :restName="restName"
      ></later-order-same-hours>
    </modal>
  </div>
</template>

<script>
import CardSmall from './CardSmall.vue'
import SectionHeading from './SectionHeading.vue'
import Modal from '../../address-components/Modal.vue'
import LaterOrderSameHours from './LaterOrderSameHours.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CardSmallList',
  components: {
    CardSmall,
    SectionHeading,
    Modal,
    LaterOrderSameHours,
  },
  created() {
    this.setInitOrthogonalRestLists()
  },
  data: function () {
    return {
      hours: {},
      restName: '',
      url: '',
      restId: '',
      showLaterOrder: false,
    }
  },
  methods: {
    ...mapActions({
      setInitOrthogonalRestLists: 'restList/setInitOrthogonalRestLists',
    }),
    showLaterOrderModal(payload) {
      document.body.classList.add('not-scrollable')
      this.hours = payload.hours
      this.restName = payload.restName
      this.url = payload.url
      this.restId = payload.restId
      this.showLaterOrder = true
      this.$nextTick(function () {
        document.getElementById('later-datepicker').focus()
      })
    },
    hideLaterOrderModal() {
      document.body.classList.remove('not-scrollable')
      this.showLaterOrder = false
    },
    goToMenu() {
      window.location.href = this.url
    },
  },
  computed: {
    ...mapState({
      orthogonalRestLists: (state) => state.restList.orthogonalRestLists,
    }),
  },
}
</script>

<style lang="scss" scoped>
.section {
  margin-bottom: $section-spacing;
}

.small-card-list-wrapper {
  overflow: auto;
  padding: 3px 0;

  @media (max-width: $max-content-width + (2 * $container-padding)) {
    padding: 3px 0 3px $container-padding;
  }
}

.small-card-list {
  width: $max-content-width;
  display: flex;

  @media (min-width: $max-content-width + (2 * $container-padding) + 1) {
    margin-left: auto;
    margin-right: auto;
  }
}

.small-card-list-item {
  flex: 0 0 275px;

  &:not(:last-of-type) {
    margin-right: 10px;
  }

  @media (min-width: $mobilePortrait) {
    flex: 0 0 284px;

    &:not(:last-of-type) {
      margin-right: 15px;
    }
  }
}
</style>
